var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-wrapper",class:{ locked: _vm.locked }},[(_vm.locked)?_c('div',{staticClass:"locked"},[_vm._v("Auftrag geschlossen")]):_vm._e(),_c('QuestionForm',{ref:"question_form",attrs:{"disabled":_vm.locked},on:{"save":_vm.save},model:{value:(_vm.formular),callback:function ($$v) {_vm.formular=$$v},expression:"formular"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }